<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-4">A<span class="smallcaps">BBREVIATIONS</span></h1>
<h1 class="sec1" id="sec-1"><em>Primary Sources</em></h1>
<table>
<tbody>
<tr>
<td class="td3">
<p class="t-left"><em>BGU</em></p></td>
<td class="td4">
<p class="t-left"><em>Ägyptische Urkunden aus den Königlichen Staatlichen Museen zu Berlin, Griechische Urkunden</em>. 19 vols. Berlin: Weidmann, 1895–</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>CIL</em></p></td>
<td class="td4">
<p class="t-left"><em>Corpus Inscriptionum Latinarum</em>. 17 vols. Berlin, 1862–</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left">CCSL</p></td>
<td class="td4">
<p class="t-left">Corpus Christianorum: Series Latina</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>IG</em> XII</p></td>
<td class="td4">
<p class="t-left"><em>Inscriptiones Graecae</em>, XII: <em>Inscriptiones insularum maris Aegaei praeter Delum: 4. Inscriptiones Coi, Calymnae, Insularum Milesiarum.</em> Edited by Dimitris Bosnakis and Klaus Hallof. Berlin: de Gruyter, 2012</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left">IKosPH</p></td>
<td class="td4">
<p class="t-left">Paton, William R., and Edward L. Hicks, eds. <em>The Inscriptions of Cos</em>. Oxford, 1891. Reprint: Hildesheim, 1990</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left">IRhodM</p></td>
<td class="td4">
<p class="t-left">Maiuri, Amedeo, ed. <em>Nuova silloge epigrafica di Rodi e Cos</em>. Florence: Le Monnier, 1925</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>Iscr. di Cos</em></p></td>
<td class="td4">
<p class="t-left"><em>Iscrizioni di Cos</em>. Edited by Mario Segre. Monografie della Scuola Archeologica di Atene e delle Missioni Italiane in Oriente, 6. Rome: L’Erma di Bretschneider, 1993</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left">Kent</p></td>
<td class="td4">
<p class="t-left">Kent, John Harvey. <em>The Inscriptions: 1926–1950</em>. Vol. 8.3 of <em>Corinth: Results of Excavations Conducted by the American School of Classical Studies at Athens</em>. Princeton: The American School of Classical Studies at Athens, 1966</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left">LCL</p></td>
<td class="td4">
<p class="t-left">Loeb Classical Library</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left">OECT</p></td>
<td class="td4">
<p class="t-left">Oxford Early Christian Texts</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>TAM</em> II</p></td>
<td class="td4">
<p class="t-left">Kalinka Ernst, ed. <em>Tituli Lyciae linguis Graeca et Latina conscripti.</em> Vol. 2 of <em>Tituli Asiae Minoris.</em> Vienna: Hölder, 1920–1944</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left">TGV</p></td>
<td class="td4">
<p class="t-left">Η Αγία Γραφή στη Δημοτική (Today’s Greek Version). Athens: Hellenic Bible Society, 1997</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left">West</p></td>
<td class="td4">
<p class="t-left">West, Allen Brown. <em>Latin Inscriptions: 1896–1926.</em> Vol. 8.2 of <em>Corinth: Results of Excavations Conducted by the American School of Classical Studies at Athens.</em> Cambridge: Harvard University Press for the American School of Classical Studies at Athens, 1931</p></td>
</tr>
</tbody>
</table>
<h1 class="sec1" id="sec-2"><em>Secondary Sources and Reference Works</em></h1>
<table>
<tbody>
<tr>
<td class="td3">
<p class="t-left">AAR</p></td>
<td class="td4">
<p class="t-left">American Academy of Religion</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>AGG</em></p></td>
<td class="td4">
<p class="t-left">von Siebenthal, Heinrich. <em>Ancient Greek Grammar for the Study of the New Testament</em>. Oxford: Lang, 2019</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>BABESCH</em></p></td>
<td class="td4">
<p class="t-left"><em>Bulletin Antieke Beschaving</em></p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left">BARIS</p></td>
<td class="td4">
<p class="t-left">BAR (British Archaeological Reports) International Series</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left">BDAG</p></td>
<td class="td4">
<p class="t-left">Danker, Frederick W., Walter Bauer, William F. Arndt, and F. Wilbur Gingrich. <em>Greek-English Lexicon of the New Testament and Other Early Christian Literature</em>. 3rd ed. Chicago: University of Chicago Press, 2000. Numbers refer to the entries of the digital version of BibleWorks.</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left">BECNT</p></td>
<td class="td4">
<p class="t-left">Baker Exegetical Commentary on the New Testament</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>Bib</em></p></td>
<td class="td4">
<p class="t-left"><em>Biblica</em></p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>BTZ</em></p></td>
<td class="td4">
<p class="t-left"><em>Berliner Theologische Zeitschrift</em></p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>BZ</em></p></td>
<td class="td4">
<p class="t-left"><em>Biblische Zeitschrift</em></p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left">BZNW</p></td>
<td class="td4">
<p class="t-left">Beihefte zur Zeitschrift für die neutestamentliche Wissenschaft</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>CBQ</em></p></td>
<td class="td4">
<p class="t-left"><em>Catholic Biblical Quarterly</em></p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>CBR</em></p></td>
<td class="td4">
<p class="t-left"><em>Currents in Biblical Research</em></p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left">CCSL</p></td>
<td class="td4">
<p class="t-left">Corpus Christianorum: Series Latina. Turnhout: Brepols, 1953–</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>CGL</em></p></td>
<td class="td4">
<p class="t-left">Diggle, James, ed. <em>The Cambridge Greek Lexicon</em>. Cambridge: Cambridge University Press, 2021</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>CJ</em></p></td>
<td class="td4">
<p class="t-left"><em>Classical Journal</em></p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>ClQ</em></p></td>
<td class="td4">
<p class="t-left"><em>Classical Quarterly</em></p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left">ECL</p></td>
<td class="td4">
<p class="t-left">Early Christianity and Its Literature</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left">EKKNT</p></td>
<td class="td4">
<p class="t-left">Evangelisch-katholischer Kommentar zum Neuen Testament</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>ETL</em></p></td>
<td class="td4">
<p class="t-left"><em>Ephemerides Theologicae Lovanienses</em></p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left">FB</p></td>
<td class="td4">
<p class="t-left">Forschung zur Bibel</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>GR</em></p></td>
<td class="td4">
<p class="t-left"><em>Greece and Rome</em></p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left">HNT</p></td>
<td class="td4">
<p class="t-left">Handbuch zum Neuen Testament</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>HTR</em></p></td>
<td class="td4">
<p class="t-left"><em>Harvard Theological Review</em></p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>JETS</em></p></td>
<td class="td4">
<p class="t-left"><em>Journal of the Evangelical Theological Society</em></p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>JRS</em></p></td>
<td class="td4">
<p class="t-left"><em>Journal of Roman Studies</em></p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>JSNT</em></p></td>
<td class="td4">
<p class="t-left"><em>Journal for the Study of the New Testament</em></p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left">JSNTSup</p></td>
<td class="td4">
<p class="t-left">Journal for the Study of the New Testament Supplement Series</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>JTS</em></p></td>
<td class="td4">
<p class="t-left"><em>Journal of Theological Studies</em></p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left">L&amp;N</p></td>
<td class="td4">
<p class="t-left">Louw, Johannes P., and Eugene A. Nida, eds. <em>Greek-English Lexicon of the New Testament: Based on Semantic Domains.</em> 2nd ed. New York: United Bible Societies, 1989</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left">LNTS</p></td>
<td class="td4">
<p class="t-left">The Library of New Testament Studies</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left">LSJM</p></td>
<td class="td4">
<p class="t-left">Liddell, Henry G., and Robert Scott. <em>A Greek-English Lexicon.</em> Revised and supplemented by H. S. Jones with the help of von R. McKenzie. 9th ed. with revised supplement. Oxford: Clarendon, 1996. Numbers refer to the entries of the online version: <a href="http://stephanus.tlg.uci.edu/lsj" target="_blank">http://stephanus.tlg.uci.edu/lsj/</a></p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left">NAC</p></td>
<td class="td4">
<p class="t-left">New American Commentary</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>Neot</em></p></td>
<td class="td4">
<p class="t-left"><em>Neotestmentica</em></p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>NIB</em></p></td>
<td class="td4">
<p class="t-left">Keck, Leander E., ed. <em>The New Interpreter’s Bible</em>. 12 vols. Nashville: Abingdon, 1994–2004</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left">NICNT</p></td>
<td class="td4">
<p class="t-left">New International Commentary on the New Testament</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>NIDNTTE</em></p></td>
<td class="td4">
<p class="t-left">Silva, Moisés, ed. <em>New International Dictionary of New Testament Theology and Exegesis</em>. 5 vols. Grand Rapids: Zondervan, 2014</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>NovT</em></p></td>
<td class="td4">
<p class="t-left"><em>Novum Testamentum</em></p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left">NovTSup</p></td>
<td class="td4">
<p class="t-left">Supplements to Novum Testamentum</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>NTS</em></p></td>
<td class="td4">
<p class="t-left"><em>New Testament Studies</em></p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>RIC</em></p></td>
<td class="td4">
<p class="t-left"><em>Roman Imperial Coinage: Volume 1—From 31 BC to AD 69.</em> Revised ed. Edited by C. H. V. Sutherland and R. A. G. Carson. London: Spink and Son, 1984</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>RPC</em></p></td>
<td class="td4">
<p class="t-left"><em>Roman Provincial Coinage.</em> Edited by Andrew Burnett et al. London: British Museum Press; Paris: Bibliothèque Nationale, 1992–</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>RTR</em></p></td>
<td class="td4">
<p class="t-left"><em>Reformed Theological Review</em></p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left">SBL</p></td>
<td class="td4">
<p class="t-left">Society of Biblical Literature</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left">SBLRBS</p></td>
<td class="td4">
<p class="t-left">Society of Biblical Literature Resources for Biblical Studies</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left">SemeiaSt</p></td>
<td class="td4">
<p class="t-left">Semeia Studies</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>SJT</em></p></td>
<td class="td4">
<p class="t-left"><em>Scottish Journal of Theology</em></p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left">SNTSU</p></td>
<td class="td4">
<p class="t-left">Studien zum Neuen Testament und seiner Umwelt</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left">SSA</p></td>
<td class="td4">
<p class="t-left">Semantic and Structural Analysis Series</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left">SymS</p></td>
<td class="td4">
<p class="t-left">Symposium Series</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>TAPA</em></p></td>
<td class="td4">
<p class="t-left"><em>Transactions of the American Philological Association</em></p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left">TAPS</p></td>
<td class="td4">
<p class="t-left">Transactions of the American Philosophical Society</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>TBLNT</em><sup>2</sup></p></td>
<td class="td4">
<p class="t-left">Coenen, Lothar, and Klaus Haacker, eds. <em>Theologisches Begriffslexikon zum Neuen Testament</em>. Rev. ed. in one vol. (“3. Sonderauflage”; slightly supplemented version of the revised two-volume edition of 1997/2000). Wuppertal: Brockhaus, 2014</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>TDNT</em></p></td>
<td class="td4">
<p class="t-left">Kittel, Gerhard, and Gerhard Friedrich, eds. <em>Theological Dictionary of the New Testament</em>. Translated by Geoffrey W. Bromiley. 10 vols. Grand Rapids: Eerdmans, 1964–1976</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left">TENTS</p></td>
<td class="td4">
<p class="t-left">Texts and Editions for New Testament Study</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>TLG</em></p></td>
<td class="td4">
<p class="t-left"><em>Thesaurus Linguae Graecae: Canon of Greek Authors and Works.</em> Edited by Luci Berkowitz and Karl A. Squitier. 3rd ed. New York: Oxford University Press, 1990</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>TLZ</em></p></td>
<td class="td4">
<p class="t-left"><em>Theologische Literaturzeitung</em></p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>TWNT</em></p></td>
<td class="td4">
<p class="t-left">Kittel, Gerhard, and Gerhard Friedrich, eds. <em>Theologische Wörterbuch zum Neuen Testament</em>. Stuttgart: Kohlhammer, 1932–1979</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>TynBul</em></p></td>
<td class="td4">
<p class="t-left"><em>Tyndale Bulletin</em></p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left">WUNT</p></td>
<td class="td4">
<p class="t-left">Wissenschaftliche Untersuchungen zum Neuen Testament</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left">YCS</p></td>
<td class="td4">
<p class="t-left">Yale Classical Studies</p></td>
</tr>
<tr>
<td class="td3">
<p class="t-left"><em>ZNW</em></p></td>
<td class="td4">
<p class="t-left"><em>Zeitschrift für die neutestamentliche Wissenschaft und die Kunde der älteren Kirche</em></p></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 009_Abbreviation.vue?6516986a